import LegalFooter from "./components/LegalFooter";

export default function RefundPolicy() {
  return (
    <div style={s.scrollPage}>
      {/* HEADER */}
      <div style={s.header}>
        <div style={s.title}>Refund Policy</div>
        <div style={s.subTitle}>
          SpeedDigits Trainer • Last Updated: January 2026
        </div>
      </div>

      {/* INTRO */}
      <p style={s.intro}>
        This Refund Policy explains the conditions related to payments, refunds,
        and future monetization of the SpeedDigits Trainer application. This
        policy applies equally to Guest users and Registered (Logged-in) users.
      </p>

      {/* SECTION 1 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>1. Free Use at Present</h2>
      <p style={s.text}>
        SpeedDigits Trainer is currently provided as a free-to-use educational
        and arithmetic training application.
      </p>

      {/* SECTION 2 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>2. No Paid Services or Subscriptions</h2>
      <p style={s.text}>
        At this time, the Application does not offer any paid plans,
        subscriptions, premium features, or in-app purchases.
      </p>

      {/* SECTION 3 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>3. No Payments Collected</h2>
      <ul style={s.list}>
        <li>No payment or billing information is collected from users</li>
        <li>No transaction processing occurs within the Application</li>
        <li>
          No financial obligation exists between the user and the Application
        </li>
      </ul>

      {/* SECTION 4 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>4. Refund Eligibility</h2>
      <p style={s.text}>
        Since no payments are accepted at present, there are no charges applied
        to users and therefore no refunds, reimbursements, or cancellations are
        applicable.
      </p>

      {/* SECTION 5 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>5. Free Access Limitations</h2>
      <p style={s.text}>
        Free access to the Application does not guarantee permanent availability
        of any feature, configuration, or functionality.
      </p>
      <p style={s.text}>
        Features may be modified, limited, or removed without compensation.
      </p>

      {/* SECTION 6 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>6. No Compensation for Feature Changes</h2>
      <p style={s.text}>
        No compensation, credits, refunds, or replacements will be provided for
        changes, removals, or limitations applied to free features.
      </p>

      {/* SECTION 7 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>7. Future Paid Features</h2>
      <p style={s.text}>
        In the future, SpeedDigits Trainer may introduce optional paid features,
        premium tools, or advanced learning modules.
      </p>
      <p style={s.text}>
        If such features are introduced, a revised Refund Policy will be
        published clearly outlining pricing details, refund eligibility, and
        applicable terms before any payment is required.
      </p>

      {/* SECTION 8 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>8. Legal Compliance</h2>
      <p style={s.text}>
        Any future refund policy will comply with applicable laws and
        regulations in effect at the time of purchase.
      </p>

      {/* SECTION 9 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>9. Policy Updates</h2>
      <p style={s.text}>
        This Refund Policy may be updated from time to time to reflect changes
        in features or business model. Updates will be indicated by revising the
        “Last Updated” date at the top of this page.
      </p>

      {/* SECTION 10 */}
      <div style={s.divider} />
      <h2 style={s.sectionTitle}>10. Contact</h2>
      <p style={s.text}>
        For any questions regarding this Refund Policy, users may refer to the
        Contact section available within the Application.
      </p>

      <LegalFooter styles={s} />
    </div>
  );
}

/* ================= STYLES (UNCHANGED) ================= */

const s = {
  scrollPage: {
    height: "calc(100vh - var(--topbar-height))",
    overflowY: "auto",
    padding: "40px 24px 80px",
  },

  header: {
    textAlign: "center",
    marginBottom: 40,
  },

  page: {
    maxWidth: 960,
    margin: "0 auto",
    padding: "40px 16px 80px",
  },

  title: {
    fontSize: "clamp(32px, 6vw, 52px)",
    fontWeight: 800,
    background: "linear-gradient(90deg,#9333ea,#ec4899)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subTitle: {
    marginTop: 10,
    fontSize: 14,
    opacity: 0.7,
  },

  intro: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 1.8,
    opacity: 0.85,
    maxWidth: 760,
    margin: "0 auto 40px",
  },

  divider: {
    width: 240,
    margin: "44px auto",
    borderBottom: "2px dotted rgba(147,51,234,0.55)",
  },

  sectionTitle: {
    textAlign: "center",
    fontSize: 22,
    fontWeight: 700,
    color: "#a855f7",
    marginBottom: 16,
  },

  text: {
    fontSize: 15,
    lineHeight: 1.8,
    marginBottom: 14,
  },

  list: {
    paddingLeft: 22,
    marginBottom: 16,
    lineHeight: 1.9,
  },
};
